import React, {Component} from "react";

import Checkbox from 'rc-checkbox';

function BrandFilter(props) {
	let brands = (typeof props.brands == 'undefined') ? [] : props.brands;

	function handleChange(e, attributeId, element) {
		if (typeof props.onCheckboxChange == 'function') {
			props.onCheckboxChange(e, attributeId, element);
		}
	}

	return (
		<div className="filter">
			<h6>Brand</h6>
			{Object.keys(brands).map(element => {
				return (
					<div key={element}>
						<label>
							<Checkbox
								type="checkbox"
								defaultChecked={false}
								onChange={(e) => handleChange(e, "brand", element)}
							/>
							&nbsp;{element} ({brands[element]})
						</label>
					</div>
				);
			})}
		</div>
	);
}

export default BrandFilter;